<div class="kpi" [class]="classeDoTom()">
    <!-- O ícone repete o que o rótulo já diz; anunciá-lo faria o leitor de tela ouvir duas vezes. -->
    <span class="kpi-selo" aria-hidden="true"><i [class]="icone()"></i></span>

    <div class="kpi-textos">
        <span class="kpi-valor">{{ valor() }}</span>
        <span class="kpi-rotulo">{{ rotulo() }}</span>
        @if (legenda()) {
            <span class="kpi-legenda">{{ legenda() }}</span>
        }
    </div>
</div>
